module.exports = __webpack_public_path__ + "img/8.041f9529.png";